import { useState } from "react";
import { Link } from "react-router-dom";
import { Acquisition } from "../lib/api.js";

const C = {
  navy: "#0E1A2E", navyDeep: "#070D1B", red: "#C8302A",
  amber: "#E8A317", green: "#0F8B3D",
  white: "#FFFFFF", cream: "#FAF7F1", sand: "#F0EADB",
  border: "#E0D9C8", line: "#EBE4D2",
  text: "#1A1A1A", text2: "#3A3A3A", text3: "#6A6A6A", text4: "#9A9A9A",
};

export default function Enterprise() {
  const [form, setForm] = useState({
    name: "", phone: "", email: "", business_name: "",
    monthly_volume: "5000-50000", pain_point: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const update = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async () => {;
    setBusy(true);
    setError(null);
    try {
      let phone = form.phone.trim().replace(/[\s-]/g, "");
      if (!phone.startsWith("+")) phone = phone.startsWith("91") ? `+${phone}` : `+91${phone}`;
      await Acquisition.lead({ ...form, phone, segment: "enterprise" });
      setSubmitted(true);
    } catch (err) {
      setError(err.message || "Could not submit. Please email enterprise@shiftswift.in directly.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", background: C.cream,
      fontFamily: "-apple-system, system-ui, Inter, sans-serif",
    }}>
      <div style={{
        background: C.white, borderBottom: `1px solid ${C.line}`,
        padding: "16px 24px",
      }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Link to="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{
              width: 32, height: 32, background: C.red, borderRadius: 8,
              display: "flex", alignItems: "center", justifyContent: "center",
              color: C.white, fontWeight: 800, fontSize: 16, letterSpacing: -1,
            }}>S</div>
            <div style={{ fontSize: 17, fontWeight: 800, color: C.navy, letterSpacing: -0.5 }}>Shiftswift</div>
          </Link>
        </div>
      </div>

      <div style={{ maxWidth: 1000, margin: "0 auto", padding: "60px 24px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 56, alignItems: "flex-start" }}>
          <div>
            <div style={{ fontSize: 11, color: C.red, letterSpacing: 2.5, fontWeight: 700, marginBottom: 16 }}>
              FOR ENTERPRISES
            </div>
            <h1 style={{ fontSize: 40, fontWeight: 800, color: C.navy, margin: 0, letterSpacing: -1.2, lineHeight: 1.1 }}>
              Talk to enterprise sales.
            </h1>
            <p style={{ fontSize: 16, color: C.text2, marginTop: 20, lineHeight: 1.6 }}>
              Banks, insurers, retailers, and government departments shipping thousands of parcels a month —
              we offer dedicated account management, SLAs, custom rate slabs, and compliance-ready reporting.
            </p>
            <div style={{ marginTop: 28 }}>
              {[
                "Multi-branch accounts with consolidated billing",
                "GSTR-1 ready monthly statements",
                "Dedicated account manager and priority support",
                "Custom SLAs and volume-based rate slabs",
                "Sovereign deployment for regulated industries",
              ].map((p, i) => (
                <div key={i} style={{ display: "flex", alignItems: "flex-start", gap: 12, marginBottom: 10 }}>
                  <span style={{
                    width: 16, height: 16, borderRadius: 8, background: C.green,
                    color: C.white, fontSize: 10, fontWeight: 800,
                    display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: 3,
                  }}>✓</span>
                  <span style={{ fontSize: 14, color: C.text }}>{p}</span>
                </div>
              ))}
            </div>
            <div style={{
              marginTop: 32, padding: 20, background: C.white,
              borderRadius: 10, border: `1px solid ${C.line}`,
            }}>
              <div style={{ fontSize: 12, color: C.red, letterSpacing: 1.5, fontWeight: 700, marginBottom: 8 }}>
                DIRECT CONTACT
              </div>
              <div style={{ fontSize: 14, color: C.text, lineHeight: 1.7 }}>
                <strong>Email:</strong> enterprise@shiftswift.in<br />
                <strong>Phone:</strong> +91 — — — — — — — — — —
              </div>
            </div>
          </div>

          <div>
            {submitted ? (
              <div style={{
                background: C.white, borderRadius: 12, padding: 36,
                border: `1px solid ${C.line}`, textAlign: "center",
              }}>
                <div style={{
                  width: 56, height: 56, borderRadius: 28, background: C.green,
                  margin: "0 auto 20px", display: "flex", alignItems: "center", justifyContent: "center",
                  color: C.white, fontSize: 28, fontWeight: 800,
                }}>✓</div>
                <div style={{ fontSize: 22, fontWeight: 800, color: C.navy, letterSpacing: -0.5 }}>
                  Got it. We'll be in touch.
                </div>
                <p style={{ fontSize: 14, color: C.text2, marginTop: 12, lineHeight: 1.6 }}>
                  Our enterprise team will reach out within 1 business day to schedule a discovery call.
                </p>
                <Link to="/" style={{
                  display: "inline-block", marginTop: 20,
                  fontSize: 14, color: C.red, fontWeight: 700, textDecoration: "none",
                }}>
                  ← Back to home
                </Link>
              </div>
            ) : (
              <div style={{
                background: C.white, borderRadius: 12, padding: 32,
                border: `1px solid ${C.line}`,
              }}>
                <div style={{ fontSize: 18, fontWeight: 800, color: C.navy, marginBottom: 16, letterSpacing: -0.3 }}>
                  Tell us a bit about your shipping
                </div>
                {error && (
                  <div style={{
                    background: "#FEF2F2", border: "1px solid #FECACA", color: "#991B1B",
                    padding: 10, borderRadius: 6, fontSize: 13, marginBottom: 12,
                  }}>{error}</div>
                )}
                <Field label="Your name" value={form.name} onChange={update("name")} required />
                <Field label="Company / Organization" value={form.business_name} onChange={update("business_name")} required />
                <Field label="Email" type="email" value={form.email} onChange={update("email")} required />
                <Field label="Phone" type="tel" value={form.phone} onChange={update("phone")} required placeholder="+91 98765 43210" />
                <SelectField label="Approximate monthly volume" value={form.monthly_volume} onChange={update("monthly_volume")}
                  options={[
                    ["500-5000", "500 – 5,000 / month"],
                    ["5000-50000", "5,000 – 50,000 / month"],
                    ["50000+", "50,000+ / month"],
                  ]}
                />
                <div style={{ marginBottom: 14 }}>
                  <label style={{ fontSize: 12, color: C.text2, fontWeight: 600, display: "block", marginBottom: 6 }}>
                    What are you trying to solve?
                  </label>
                  <textarea
                    value={form.pain_point} onChange={(e) => update("pain_point")(e.target.value)}
                    rows={3} placeholder="e.g. We're spending too much on private couriers, or we need consolidated billing across 50 branches."
                    style={{
                      width: "100%", padding: "12px 14px",
                      border: `1px solid ${C.border}`, borderRadius: 7,
                      fontSize: 14, boxSizing: "border-box", background: C.cream,
                      fontFamily: "inherit", outline: "none", resize: "vertical",
                    }}
                  />
                </div>
                <button type="button" onClick={submit} disabled={busy} style={{
                  width: "100%", background: busy ? C.text4 : C.navy, color: C.white,
                  border: "none", padding: "14px", borderRadius: 8,
                  fontSize: 15, fontWeight: 700, cursor: busy ? "not-allowed" : "pointer",
                  marginTop: 8,
                }}>
                  {busy ? "Sending..." : "Request a call"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, type = "text", value, onChange, required, placeholder }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ fontSize: 12, color: C.text2, fontWeight: 600, display: "block", marginBottom: 6 }}>
        {label}
      </label>
      <input
        type={type} value={value} onChange={(e) => onChange(e.target.value)}
        required={required} placeholder={placeholder}
        style={{
          width: "100%", padding: "12px 14px",
          border: `1px solid ${C.border}`, borderRadius: 7,
          fontSize: 14, boxSizing: "border-box", background: C.cream,
          fontFamily: "inherit", outline: "none",
        }}
      />
    </div>
  );
}

function SelectField({ label, value, onChange, options }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{ fontSize: 12, color: C.text2, fontWeight: 600, display: "block", marginBottom: 6 }}>
        {label}
      </label>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={{
        width: "100%", padding: "12px 14px",
        border: `1px solid ${C.border}`, borderRadius: 7,
        fontSize: 14, boxSizing: "border-box", background: C.cream,
        fontFamily: "inherit", outline: "none",
      }}>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
    </div>
  );
}
